<template>
  <el-submenu :index="item.index" v-if="item.children&&item.children.length>0" v-has-permission="item.permission">
    <template slot="title">
      <!-- <font-awesome-icon :icon="item.icon" v-if="item.icon"></font-awesome-icon> -->
      <text-formatter type="icons" v-model="item.icon" class="width20"></text-formatter>
      <span slot="title">{{item.label}}</span>
    </template>
    <template v-for="c in item.children">
      <TreeMenuItem :item="c"   :key="c.index"></TreeMenuItem>
    </template>
  </el-submenu>
  <el-menu-item v-else v-has-permission="item.permission"
                :key="item.index"
                :index="item.index"
                :route="item.route">
    <!-- <font-awesome-icon :icon="item.icon" v-if="item.icon"></font-awesome-icon> -->
    <!-- <text-formatter type="icons" v-model="item.icon" class="width20"></text-formatter> -->
    <span class="menu-item-content" slot="title">
      {{item.label}}
    </span>
  </el-menu-item>
</template>

<script>
export default {
    name: `TreeMenuItem`,
    props: {
        item: { type: Object, required: true }
    },
    computed: {

    }
}
</script>

<style scoped>
  .el-menu {
    text-align: left;
  }
  .menu-item-content {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    width:100%;
  }
  .el-tooltip{
    border:none;
  }
</style>



// WEBPACK FOOTER //
// src/common/TreeMenuItem.vue